module.exports = __webpack_public_path__ + "img/avatar-profile.1f42b7b1.svg";